const KEY = 'sl.selected-account';

/** Only our opaque account key is remembered; the session remains the authority on accessible accounts. */
export function rememberedAccount(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}
export function rememberAccount(id: string) {
  try {
    sessionStorage.setItem(KEY, id);
  } catch {
    /* A blocked store does not prevent switching. */
  }
}
